import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import React from 'react';

import styles from './FormField.module.scss';
import { FormFieldProps } from './types';

export const FormField = ({
  className,
  errors,
  children,
  label,
  dataTestId,
}: FormFieldProps) => {
  return (
    <div
      className={classNames(styles.wrapper, className)}
      data-testid={dataTestId}
    >
      {label && (
        <Typography
          tagName={TypographySizes.div}
          mods={[TypographyMods.captionS]}
        >
          <label className={styles.label}>{label}</label>
        </Typography>
      )}
      {children}
      <ul className={styles.errors}>
        {errors &&
          ([] as string[]).concat(errors).map((error, index) => (
            <li className={styles.error} key={index}>
              <Typography
                tagName={TypographySizes.div}
                mods={[TypographyMods.captionS]}
              >
                {error}
              </Typography>
            </li>
          ))}
      </ul>
    </div>
  );
};
